module.exports = __webpack_public_path__ + "static/media/stop-icon.dbb2dc4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/stop-icon.svg
// module id = 653
// module chunks = 0